import { css, cva } from '@/styled-system/css';

const FAB_SIZE = '66px';
const FAB_HALF_SIZE = `calc(${FAB_SIZE} / 2)`;

const HDP_WIDTH_MOBILE = '100vw';
const HDP_SINGLE_COL_WIDTH = '452px';
const HDP_DOUBLE_COL_WIDTH = '880px';

const MOBILE_COORDS_HIDDEN = `calc((${HDP_WIDTH_MOBILE} / 2) - ${FAB_HALF_SIZE}), -60px, 0px`;
const MOBILE_COORDS_DISPLAYED = `calc((${HDP_WIDTH_MOBILE} / 2) - ${FAB_HALF_SIZE}), 22px, 0px`;
const SINGLE_COL_COORDS_HIDDEN = `calc((${HDP_SINGLE_COL_WIDTH} / 2) - ${FAB_HALF_SIZE}), -60px, 0px`;
const SINGLE_COL_COORDS_DISPLAYED = `calc((${HDP_SINGLE_COL_WIDTH} / 2) - ${FAB_HALF_SIZE}), 22px, 0px`;
const DOUBLE_COL_COORDS_HIDDEN = `calc((880px / 2) - ${FAB_HALF_SIZE}), -60px, 0px`;
const DOUBLE_COL_COORDS_DISPLAYED = `calc((${HDP_DOUBLE_COL_WIDTH} / 2) - ${FAB_HALF_SIZE}), 23px, 0px`;

// hdpSharedCSSWidth equivalent - using responsive nested styles
const hdpSharedCSSWidth = {
  maxWidth: '400px',
  width: '100%',
  boxSizing: 'border-box',

  md: {
    // 768px - md-and-up
    width: '399px',
  },

  xl: {
    // 1200px - xl-and-up-bigger-listing-cards
    width: '100%',
    display: 'inline-block',
    verticalAlign: 'top',
    margin: '0',
    maxWidth: 'unset',
  },

  xxl: {
    // 1280px - xl-and-up-bigger-listing-cards
    width: '274px',
    margin: '0',
  },
};

export const hdpContactButtonV2LayoutStyles = css({
  position: 'relative',
  ...hdpSharedCSSWidth,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0',
  boxSizing: 'border-box',
});

export const styledContactButtonV2Styles = css({
  ...hdpSharedCSSWidth,
  // translateZ forces GPU acceleration
  transform: 'translateZ(0)',
  transitionProperty: 'all',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-in-out',
});

export const contactFABStyles = cva({
  base: {
    position: 'fixed',
    zIndex: 'zIndexOverParent',
    width: FAB_SIZE,
    height: FAB_SIZE,
    borderRadius: '60px',
    boxShadow: '1px 1px 2px {colors.hpxGrey600}',

    // Hide FAB completely during SSR to prevent flash
    visibility: 'hidden',
    opacity: 0,

    // When contact FAB is hidden from view
    // Mobile
    transform: `translate3d(${MOBILE_COORDS_HIDDEN})`,

    // Desktop single COL - md-and-up
    md: {
      transform: `translate3d(${SINGLE_COL_COORDS_HIDDEN})`,
    },

    // Desktop double COL - xl-and-up-bigger-listing-cards
    xxl: {
      transform: `translate3d(${DOUBLE_COL_COORDS_HIDDEN})`,
    },
  },
  variants: {
    contactButtonClass: {
      compact: {
        // When contact FAB is displayed
        visibility: 'visible',
        opacity: 1,
        transitionProperty: 'opacity, transform',
        transitionDuration: '0.25s, 0.25s',
        transitionTimingFunction: 'ease-in-out, ease-in-out',

        // Mobile
        transform: `translate3d(${MOBILE_COORDS_DISPLAYED})`,

        // Desktop single COL - md-and-up
        md: {
          transform: `translate3d(${SINGLE_COL_COORDS_DISPLAYED})`,
        },

        // Desktop double COL - xl-and-up-bigger-listing-cards
        xxl: {
          transform: `translate3d(${DOUBLE_COL_COORDS_DISPLAYED})`,
        },
      },
    },
  },
});
